export const FETCH_DATA_LOADING = "FETCH_DATA_LOADING";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";